export const isMaintenancePeriod = () => {
  const now = new Date();
  return (
    now > new Date(process.env.REACT_APP_MAINTENANCE_START_PERIOD) &&
    now < new Date(process.env.REACT_APP_MAINTENANCE_END_PERIOD)
  );
};
